import { useUpdateData } from 'shared/hooks/use-update-data'
import { COURSE_API } from '../../courses/curriculum/api/course-curriculum-api'
import { LectureId } from '../../courses/curriculum/types/lecture-interface'

export const useUpdateLectureEmail = (lectureId: LectureId) => {
  return useUpdateData({ api: `${COURSE_API}/lecture/${lectureId}/email` })
}
